import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import Root from './Root';
import {ready} from 'shared/utils';
import 'stylesheets/aptitude.scss';
import reducers from './reducers';
import {createStore, applyMiddleware, compose} from 'redux';
import thunkMiddleware from 'redux-thunk';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

function configureStore(preloadedState) {
  const store = createStore(
    reducers,
    preloadedState,
    composeEnhancers(applyMiddleware(thunkMiddleware))
  );

  return store;
}
ready(() => {
  if (!document.querySelectorAll('body.aptitude').length) {
    return;
  }

  const store = configureStore({});
  const root = createRoot(document.getElementById('aptitude-react-hook'));

  root.render(
    <Provider store={store}>
      <Root />
    </Provider>
  );
});
